<template>
    <section
        :class="'error error_' + status"
    >
        <div class="container">
            <div class="row flex-grow">
                <div class="col-lg-6 mx-auto">
                    <div class="row mt-5 text-center">
                        <div class="col-12 text-center">
                            <h2 v-text="lang('throttled.header')" />
                            <h3 class="font-weight-light" v-text="lang('throttled.paragraph')" />
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-12 text-center">
                            <button
                                class="btn btn-secondary"
                                :disabled="!canClick"
                                @click="retry()"
                            >
                                {{ lang('throttled.button') }}
                                <span v-if="!canClick">
                                    {{ seconds }}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import Layout from "../../Shared/Layout";
import moment from 'moment';

export default {

    data() {
        return {
            enddate:null,
            canClick:false,
            seconds:15,
        }
    },

    destroyed(){
        this.$appError.reset();
    },

    layout:Layout,

    metaInfo() {
        return {
            title: this.lang('throttled.pagetitle'),
        }
    },

    methods: {
        start() {
            this.next();
        },
        next() {
            setTimeout(() => this.check(), 1000);
        },
        check() {
            let diffinseconds = Math.ceil((this.enddate - moment().format('x')) / 1000);
            this.seconds = diffinseconds;
            if (diffinseconds > 0) {
                this.next();
            } else {
                this.canClick = true;
            }
        },
        retry() {
            this.$inertia.visit(location.href);
        },
    },

    mounted(){
        this.enddate = moment().add(this.seconds,'seconds').format('x');
        this.start();
        this.$appError.set('', 'Niet zo snel!');
    },

    props: {
        status: Number,
    },
}
</script>
